import axios from "axios";
import { createStandaloneToast } from "@chakra-ui/react";

const { toast } = createStandaloneToast();

// Create axios instance
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

// 🔥 Request interceptor to add token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("prima_session");
    if (token) {
      // Add Authorization header with Bearer token
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle unauthorized requests and session invalidation
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      // 🔥 Handle all 401 Unauthorized responses
      if (status === 401) {
        console.log(
          "[Axios Interceptor] 401 Unauthorized - Session invalid:",
          data?.message
        );

        // Show toast notification with appropriate message
        const message = data?.message || "Your session has expired. Please login again.";
        
        // toast({
        //   title: "Session Expired",
        //   description: message,
        //   status: "error",
        //   duration: 4000,
        //   isClosable: true,
        // });

        // Clear all session data
        localStorage.removeItem("prima_session");
        localStorage.removeItem("prima_user");
        
        // Clear any other cached data if needed
        sessionStorage.clear();

        // Note: TokenExpiredScreen will be shown by AuthValidationLayer/App.jsx
        // User will click Sign In button to navigate to login

        // Return rejected promise to prevent further error propagation
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
